<mat-dialog-content>
  <ng-container [formGroup]="model">
    <mat-form-field libZalamoField>
      <mat-label> Rodzaj działalności</mat-label>
      <mat-select formControlName="businessType">
        <mat-option value="2">Jednoosobowa działalność gospodarcza</mat-option>
        <mat-option value="3">Spółka cywilna</mat-option>
        <mat-option value="4">Spółka jawna</mat-option>
        <mat-option value="5">Spółka komandytowa</mat-option>
        <mat-option value="6">Spółka komandytowo-akcyjna</mat-option>
        <mat-option value="7">Spółka akcyjna</mat-option>
        <mat-option value="8"
          >Spółka z ograniczoną odpowiedzialnością</mat-option
        >
        <mat-option value="9"
          >Stowarzyszenie, fundacja, organizacja pożytku publicznego
        </mat-option>
        <mat-option value="10">Spółdzielnia</mat-option>
      </mat-select>
      <lib-zalamo-field-decoration></lib-zalamo-field-decoration
    ></mat-form-field>
    <mat-form-field libZalamoField>
      <mat-label>Nazwa firmy</mat-label>
      <input type="text" matInput formControlName="name" />
      <lib-zalamo-field-decoration></lib-zalamo-field-decoration
    ></mat-form-field>
    <mat-form-field libZalamoField>
      <mat-label>Number telefonu</mat-label>
      <input type="text" matInput formControlName="phoneNumber" />
      <lib-zalamo-field-decoration></lib-zalamo-field-decoration
    ></mat-form-field>
    <mat-form-field libZalamoField>
      <mat-label>Numer konta</mat-label>
      <input type="text" matInput formControlName="bankAccount" />
      <lib-zalamo-field-decoration></lib-zalamo-field-decoration
    ></mat-form-field>
    @if (
      model.value.businessType &&
      !['1', '2', '3'].includes(model.value.businessType)
    ) {
      <mat-form-field libZalamoField>
        <mat-label>KRS</mat-label>
        <input type="text" matInput formControlName="krs" />
        <lib-zalamo-field-decoration></lib-zalamo-field-decoration
      ></mat-form-field>
    }
    <mat-form-field libZalamoField>
      <mat-label>NIP</mat-label>
      <input type="text" matInput formControlName="nip" />
      <lib-zalamo-field-decoration></lib-zalamo-field-decoration
    ></mat-form-field>
    <mat-form-field libZalamoField>
      <mat-label>Regon</mat-label>
      <input type="text" matInput formControlName="regon" />
      <lib-zalamo-field-decoration></lib-zalamo-field-decoration
    ></mat-form-field>
    <div class="representatives" formArrayName="representatives">
      <h2>Osoby uprawione do reprezentacji</h2>
      @for (
        item of representatives.controls;
        track item;
        let isFirst = $first;
        let i = $index
      ) {
        <div [formGroup]="item">
          @if (!isFirst) {
            <lib-button icon-only (click)="representatives.removeAt(i)">
              <mat-icon>delete</mat-icon>
            </lib-button>
          }
          <mat-form-field libZalamoField>
            <mat-label>Osoba</mat-label>
            <input type="text" matInput formControlName="name" />
            <lib-zalamo-field-decoration></lib-zalamo-field-decoration
          ></mat-form-field>
          <mat-form-field libZalamoField [noBottomMargin]="true">
            <mat-label>PESEL</mat-label>
            <input type="text" matInput formControlName="pesel" />
            <lib-zalamo-field-decoration></lib-zalamo-field-decoration
          ></mat-form-field>
        </div>
      }
      <lib-button (click)="addRep()">Dodaj osobę</lib-button>
    </div>
    <mat-form-field libZalamoField>
      <mat-label>Osoba kontaktowa</mat-label>
      <input type="text" matInput formControlName="contactPersonName" />
      <lib-zalamo-field-decoration></lib-zalamo-field-decoration
    ></mat-form-field>

    <mat-form-field libZalamoField>
      <mat-label> Numer telefonu osoby kontaktowej</mat-label>
      <input type="text" matInput formControlName="contactPersonPhoneNumber" />
      <lib-zalamo-field-decoration></lib-zalamo-field-decoration
    ></mat-form-field>

    <mat-form-field libZalamoField>
      <mat-label>Miasto</mat-label>
      <input type="text" matInput formControlName="addressCity" />
      <lib-zalamo-field-decoration></lib-zalamo-field-decoration
    ></mat-form-field>
    <mat-form-field libZalamoField>
      <mat-label>Kod pocztowy</mat-label>
      <input type="text" matInput formControlName="addressPostCode" />
      <lib-zalamo-field-decoration></lib-zalamo-field-decoration
    ></mat-form-field>
    <mat-form-field libZalamoField>
      <mat-label>Ulica</mat-label>
      <input type="text" matInput formControlName="addressStreet" />
      <lib-zalamo-field-decoration></lib-zalamo-field-decoration
    ></mat-form-field>

    <mat-form-field libZalamoField>
      <mat-label>Adres korespondencyjny - miasto</mat-label>
      <input type="text" matInput formControlName="correspondenceAddressCity" />
      <lib-zalamo-field-decoration></lib-zalamo-field-decoration
    ></mat-form-field>
    <mat-form-field libZalamoField>
      <mat-label>Adres korespondencyjny - kod pocztowy</mat-label>
      <input
        type="text"
        matInput
        formControlName="correspondenceAddressPostCode" />
      <lib-zalamo-field-decoration></lib-zalamo-field-decoration
    ></mat-form-field>
    <mat-form-field libZalamoField>
      <mat-label>Adres korespondencyjny - ulica</mat-label>
      <input
        type="text"
        matInput
        formControlName="correspondenceAddressStreet" />
      <lib-zalamo-field-decoration></lib-zalamo-field-decoration
    ></mat-form-field>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions>
  <span #button>
    <lib-button (click)="register()" [isLoading$]="registerLoading$"
      >Zarejestruj</lib-button
    >
  </span>
  <lib-button bare mat-dialog-close>Anuluj</lib-button>
</mat-dialog-actions>
